const t = [
  /^https?:\/\//,
  /^http?:\/\//,
  /^ftp?:\/\//,
  /^ftps?:\/\//,
  /^ftps?:\/\//,
  /mailto:([^?]*)/
], s = "https://", o = {
  EDITOR_SUPPORTED_LINK_PROTOCOLS: t,
  EDITOR_DEFAULT_LINK_PREFIX: s
};
export {
  s as EDITOR_DEFAULT_LINK_PREFIX,
  t as EDITOR_SUPPORTED_LINK_PROTOCOLS,
  o as default
};
//# sourceMappingURL=editor-constants.js.map
